<template>
  <b-modal id="searchemail" centered size="lg" ref="searchEmailModal" no-close-on-esc
    no-close-on-backdrop>
    <template #modal-header class="mx-auto">
      <h5 class="modal-title">Add User</h5>
    </template>
    <template #default>
      <p>Enter the email address of the user you would like to add to the account.</p>
      <p>
        <span class="errorMessage" v-if="v$.form.searchedEmailId.$error && v$.form.searchedEmailId.required.$invalid">User
          email cannot be blank.</span>
        <span class="errorMessage"
          v-if="v$.form.searchedEmailId.$error && !v$.form.searchedEmailId.required.$invalid && v$.form.searchedEmailId.isValidEmail.$invalid">Enter
          correct email.</span>
      </p>
      <div class="row">
        <div class="col-md-2">
          <label>
            <span class="requiredinput">*</span>
            User email:
          </label>
        </div>
        <div class="col-md-10"
          :class="{ 'hasError': v$.form.searchedEmailId.$error, 'noError': v$.form.searchedEmailId.$error == false }">
          <input type="text" ref="searchedEmailId" class="ps-2 pe-2 search-email-input"
            v-model.trim="form.searchedEmailId" tabindex="1" v-sanitize-html="form.searchedEmailId" />
        </div>
      </div>
    </template>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="um-btn" @click="cancelChanges()" tabindex="3">Cancel</b-button>
      <b-button class="um-btn" @click="setUserAction($event)" tabindex="2">Next</b-button>
    </template>
  </b-modal>
  <ActivateUser :isNewUser="isNewUser" :userEmailId="userFormDetail.searchedEmailId" :accountName="accountName"
    :accountNumber="accountNumber" @OnCreateUserModalCancel="CloseSearchEmailModal" :accountId="accountId"
    :searchedUserDetail="searchedUserDetail" :activateButtonText="activateButtonText"
    :activateUserMessage="activateUserMessage"></ActivateUser>
  <CreateUser ref="createUserRef" v-if="isSearchPerform == true" :isNewUser="isNewUser" :userEmailId="userFormDetail.searchedEmailId"
    :accountName="accountName" :accountNumber="accountNumber" @OnCreateUserModalCancel="CloseSearchEmailModal"
    :accountId="accountId"></CreateUser>
  <ErrorMessage ref="errorMessageRef" :errorMessage="errorMsg" callbackOnClose="cancelChanges" @cancelChanges="cancelChanges"></ErrorMessage>
  <UserDisableError :message="errorMsg" :headerMessage="headerMessage"></UserDisableError>
  <CreateAdfsUser ref="createAdfsUserRef" :isNewUser="isNewUser" :userEmailId="userFormDetail.searchedEmailId" :accountName="accountName"
    :accountNumber="accountNumber" :accountId="accountId" :searchedUserDetail="searchedUserDetail"
    @OnCreateAdfsUserModalCancel="CloseSearchEmailModal" :actionFromEdit="false"></CreateAdfsUser>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
</template>
<script>
import { required, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import CreateUser from "./CreateUser";
import ErrorMessage from "./shared/ErrorMessage";
import UserDisableError from "./shared/UserDisableError";
import service from "../services/api.services";
import applicationSetting from "./ApplicationSetting";
import { Component as Loading } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { eventbus } from "../main";
import ActivateUser from "./shared/ActivateUser";
import CreateAdfsUser from "./shared/CreateAdfsUser";
export default {
    setup() {
        return { v$: useVuelidate() };
    },
  name: "SearchEmail",
  components: {
    CreateUser,
    ErrorMessage,
    applicationSetting,
    Loading,
    ActivateUser,
    CreateAdfsUser,
    UserDisableError
  },
  data() {
    return {
      form: {
        searchedEmailId: ""
      },
      searchedUserDetail: null,
      adminAccounts: null, //loggedInUserDetail: null,
      loggedInUserName: this.$store.getters.username,
      isLoading: false,
      fullPage: true,
      isValid: false,
      isSupportNumbersVisible: false,
      errorMsg:
        "Sorry, you do not have the required permission to add the user to this account.",
      isNewUser: true,
      isAlreadyAssociated: false,
      isSearchPerform: true,
      isEnabled: true,
      adfsUserDetails: null,
      headerMessage: "",
      activateButtonText: "",
      activateUserMessage: ""
    };
  },
  validations() {
    return {
      form: {
        searchedEmailId: {
          required, minLength: minLength(1),
          isValidEmail: (value) => this.validateEmail(value)
        }
      }
    };
  },
  props: {
    accountNumber: String,
    accountName: String,
    accountId: String
  },
  computed: {
    userFormDetail: {
      get: function () {
        return this.form;
      },
      set: function (newvalue) {
        this.form = newvalue;
      }
    }
  },
  methods: {
    validateEmail(email) {
      if (email == null) return false;
      var emailToValidate = String(email).trim();
      if (/^(?:[a-z0-9!_-]+(?:\.[a-z0-9!_-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i.test(emailToValidate)) {
        return true;
      } else {
        return false;
      }

    },
    clearForm: function () {
      var that = this;
      setTimeout(function () {
        that.form.searchedEmailId = "";
        that.v$.form.$reset();
      }, 10);
    },
    CloseSearchEmailModal: function () {
      this.isLoading = false;
      this.clearForm();
      (this.isValid = false),
        (this.errorMsg =
          "Sorry, you do not have the required permission to add the user to this account."),
        (this.isNewUser = true),
        (this.isAlreadyAssociated = false);
      this.form.searchedEmailId = "";
      this.isDirty = false;
      try {
        if (this.$refs.createAdfsUserRef && this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"])
          this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"].hide();
        else
          this.$bvModal.hide("createadfsuser");
        if (this.$refs.createUserRef) this.$refs.createUserRef.hideModal();
      } finally {
        this.$bvModal.hide("searchemail");
      }
    },
    emitMethod() {
      eventbus.emit(
        "setuserDetails",
        [this.$store.getters.searchedUserDetail, this.isNewUser, this.form.searchedEmailId]
      );
      eventbus.emit("setAdfsuserDetails", this.adfsUserDetails);
      if (
        typeof this.accountContactRelation !== "undefined" &&
        this.accountContactRelation != null
      )
        eventbus.emit("setRolesAndPermissions", this.accountContactRelation);
    },

    cancelChanges: function () {
      this.clearForm();
      this.isLoading = false;
      (this.isValid = false),
        (this.errorMsg =
          "Sorry, you do not have the required permission to add the user to this account."),
        (this.isNewUser = true),
        (this.isAlreadyAssociated = false);
      this.clearForm();
      this.$bvModal.hide("searchemail");
    },

    setUserAction: function ($event) {
      $event.target.blur();
      this.v$.form.$touch();
      if (this.v$.form.$error) {
        return;
      } else {
        var that = this;
        this.isLoading = true;
        service
          .SetUserAction(this.form.searchedEmailId, this.accountId)
          .then(result => {
            that.isLoading = false;
            if (result.data.errorMessage != null && result.data.errorMessage != "") {
              that.isSupportNumbersVisible = result.data.errorMessage.includes("This email address is associated with an inactive user");
              that.errorMsg = that.isSupportNumbersVisible ?
                "<b>" + result.data.errorMessage + "</b>" + (that.$store.getters.errorMessage != null ? that.$store.getters.errorMessage : "")
                : result.data.errorMessage;
              that.headerMessage = result.data.errorHeaderMessage
              that.$nextTick(function () {
                if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                  that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                else
                  that.$bvModal.show("errormessage");
              });
            } else {
              //Set required Flags
              that.isNewUser = result.data.isNewUser;
              that.isAlreadyAssociated =
                result.data.isUserAlreadyAssociatedToAccount;
              that.isValid = result.data.isUserAdmin;

              //Set ADFS User Detail
              that.adfsUserDetails = result.data.adfsUserDetail;

              //Set Contact Detail
              that.searchedUserDetail = result.data.sfContactDetail;
              if (!that.isNewUser && that.searchedUserDetail && result.data.adfsUserDetail)
                that.searchedUserDetail.middleInitial = result.data.adfsUserDetail.middleInitial;
              if (that.searchedUserDetail != null)
                that.searchedUserDetail.adfsGuid; //need to verify this statement

              that.$store.dispatch(
                "setSearchedUserDetail",
                result.data.sfContactDetail
              );
              if (
                result.data.accountContactRelationModel
                  .accountContactRelationList != null &&
                result.data.accountContactRelationModel
                  .accountContactRelationList.length > 0
              ) {
                that.accountContactRelation = result.data.accountContactRelationModel.accountContactRelationList.find(
                  x => x.cadebillAccountNo == this.accountNumber
                );
              }

              //Activate user popup details
              if (that.searchedUserDetail && that.searchedUserDetail.userCommunityType == "Partner User" && !that.searchedUserDetail.isCustomerCommunityUser) {
                that.activateUserMessage = "This user is currently disabled. Select Enable to continue";
                that.activateButtonText = "Enable"
              }
              else {
                that.activateUserMessage = "This user is currently disabled. Select Enable and Continue to activate the user on this account";
                that.activateButtonText = "Enable and Continue"
              }
              that.emitMethod();

              //Set User Action
              // createadfsuser id is shared with AccountUser's instance (actionFromEdit=true).
              // Drive SearchEmail's own instance (actionFromEdit=false) by ref so the correct
              // "already associated with this account but does not have a login" message shows.
              if (result.data.action === "createadfsuser"
                && that.$refs.createAdfsUserRef && that.$refs.createAdfsUserRef.$refs["createAdfsUserModal"]) {
                that.$refs.createAdfsUserRef.$refs["createAdfsUserModal"].show();
              } else {
                that.$bvModal.show(result.data.action);
              }
            }
          })
          .catch(error => {
            that.isLoading = false;
            console.log(error);
            that.accessibleApplicationList = [];
          });
      }
    }
  }
};
</script>
<style scoped>
.adduserbtn {
  margin-left: 0.8em;
  background-color: #2c87f0;
  border: 1px solid #2c87f0;
  height: 2.6em;
  border-radius: 5px;
  font-size: 0.8em;
  color: white;
  width: 5.2em;
}

.search-email-input {
  width: 300px;
}
</style>
<style>
.requiredinput {
  color: red;
}

.hasError label {
  color: red !important;
}

.hasError input {
  border-color: red !important;
}

.noError input {
  border-color: white !important;
}

.modal-backdrop {
  opacity: 0.5;
  transition: opacity 0.2s;
  border-color: red;
}

.modal-title {
  margin: auto;
}

.errorMessage {
  color: red;
  font-size: 0.8em;
  font-weight: 500;
}
</style>
